import classNames from 'classnames'

export interface FlexColProps {
    className?: string
    children?: React.ReactNode
    horizontal?: 'center'
    vertical?: 'center'
    gap?: number
    top?: number
    bottom?: number
}

export const FlexCol = (props: FlexColProps) => (
    <div
        className={classNames(props.className, 'flex-col')}
        style={{
            gap: props.gap ? props.gap * 8 : undefined,
            alignItems: props.horizontal,
            justifyContent: props.vertical,
            paddingTop: props.top ? props.top * 8 : undefined,
            paddingBottom: props.bottom ? props.bottom * 8 : undefined,
        }}
    >
        {props.children}
    </div>
)
